<template>
    <div> 
        <h1>
            All Categories Page
         </h1>
    </div>
</template>